import React from 'react';
import { UIWindowModalPages } from '../modals';
import { useLang } from '../../../_LangContext';
import Utils from '../../../_Utils';

const ModalStartUp = ({ isOpen, onClose }) =>
{
    const { lang, getTerm, getMessage } = useLang();
    const imgPath = `${process.env.PUBLIC_URL}/img/`;

    const renderPageContent = (key, scrollNext, scrollPrev, index, total) =>
    {
        return (
            <div className="page-inner">
                <div className="block text-block">
                    <figure>
                        <img src={`${imgPath}startup_attention_fig_${getImageNumber(key)}.png`} alt="" />
                    </figure>
                    <p className="message" dangerouslySetInnerHTML={{ __html: Utils.markdownToHtml(getMessage(key)) }} />
                </div>
                <div className="block btns">
                    <button 
                        className="normal w-icon" 
                        onClick={index === total - 1 ? onClose : scrollNext}
                    >
                        {index === total - 1 ? (
                            <>
                                <p className="icon check"></p>
                                <div className="btn-label">{getTerm('confirmed')}</div>
                            </>
                        ) : (
                            <div className="btn-label">{getTerm('next')}</div>
                        )}
                    </button>
                </div>
            </div>
        );
    };

    const getImageNumber = (key) =>
    {
        const imageMap = 
        {
            'startup-walking': '03',
            'startup-gps': '01',
            'startup-wifi': '02',
            'startup-stampcard': '04'
        };
        return imageMap[key];
    };

    const getNewBadge = (key) =>
    {
        // Use the new locale system to get startup data
        // For now, we'll disable the "new" badge functionality since it's not in the new locale structure
        // This can be re-enabled if needed by adding is-new flags to the locale files
        return null;
    };

    const pages = 
    [
        { 
            key: 'startup-walking',
            overlay: getNewBadge('startup-walking')
        },
        { 
            key: 'startup-gps',
            overlay: getNewBadge('startup-gps')
        },
        { 
            key: 'startup-wifi',
            overlay: getNewBadge('startup-wifi')
        },
        { 
            key: 'startup-stampcard',
            overlay: getNewBadge('startup-stampcard')
        }
    ].map(page => ({
        ...page,
        content: (scrollNext, scrollPrev, index, total) => 
            renderPageContent(page.key, scrollNext, scrollPrev, index, total)
    }
    )
    );

    return (
        <UIWindowModalPages 
            className="startup" 
            isOpen={isOpen} 
            onClose={onClose} 
            pages={pages} 
            hasClose={false} 
            thumbType='number'
            hasOverlays={true}
        />
    );
};

export default ModalStartUp;